import ImagesBlock from './component';

export default ImagesBlock;
